<script>
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import CollectionInfoBlock from "@js/components/Sections/Collection/CollectionInfoBlock.vue";
import {useCollectionStore} from "@js/store/CollectionStore.js";
import IconImage from "@js/components/Icons/IconImage.vue";
import BaseImageSlider from "@js/components/Images/BaseImageSlider.vue";
import CollectionProductList from "@js/components/Sections/Collection/CollectionProductList.vue";
import CatalogProductSkeleton from "@js/components/Sections/Catalog/ProductItem/CatalogProductSkeleton.vue";

export default {
    name: "CollectionPage",
    components: {
        CatalogProductSkeleton,
        CollectionProductList,
        BaseImageSlider,
        IconImage,
        CollectionInfoBlock,
        Breadcrumbs,
        MobileTopBar
    },
    props: {
        collection: {
            required: true,
        }
    },
    beforeMount() {
        this.collectionStore.collection = this.collection;
        this.collectionStore.getCollectionInfo()
        this.collectionStore.loadInitialProducts()
        this.collectionStore.loadImages()
    },
    setup() {
        const collectionStore = useCollectionStore()

        return {collectionStore}
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <div class="grid grid-cols-12 gap-5 mb-10">
            <div class="col-span-12 md:col-span-7">
                <BaseImageSlider v-show="collectionStore.images" :images="collectionStore.images"/>
                <div v-show="!collectionStore.images" role="status" class="space-y-4 animate-pulse">
                    <div class="flex items-center justify-center h-56 md:h-96 bg-gray-300 rounded-md">
                        <IconImage class="w-24 h-24"/>
                    </div>
                </div>
            </div>
            <div class="col-span-12 md:col-span-5">
                <CollectionInfoBlock :collection="collection"/>
            </div>
        </div>
        <CollectionProductList v-show="!collectionStore.loadings.productLoading"/>
        <div v-show="collectionStore.loadings.productLoading">
            <div class="h-8 bg-gray-200 animate-pulse rounded w-1/4 mb-4"></div>
            <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
                <CatalogProductSkeleton v-for="i in 8"/>
            </div>
        </div>

    </div>
</template>

<style scoped lang="scss">

</style>
